"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FuturesAccountSummaryContainer = void 0;
var _reactRedux = require("react-redux");
var _FuturesAccountSummaryComponent = _interopRequireDefault(require("./FuturesAccountSummaryComponent"));
var _futuresSelectors = require("../../../redux/futures/selectors/futuresSelectors");
var _productsSelectors = require("../../../redux/selectors/productsSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var baseAsset = (0, _productsSelectors.baseNotionalProductSelector)(state);
  var _futuresAccountInfoSe = (0, _futuresSelectors.futuresAccountInfoSelector)(state),
    summary = _futuresAccountInfoSe.accountInfo;
  return {
    summary: summary,
    baseAsset: baseAsset
  };
};
var FuturesAccountSummaryContainer = exports.FuturesAccountSummaryContainer = (0, _reactRedux.connect)(mapStateToProps)(_FuturesAccountSummaryComponent["default"]);